import { Component, ChangeDetectionStrategy } from '@angular/core'
import { ModalComponent } from './modal/modal.component'
import { ModalService } from '../../../services/modal.service'
import { TranslocoDirective } from '@jsverse/transloco'
import { LoginFormComponent } from '../other/authentication/login-form/login-form.component'

export interface LoginModalData {
	title: string;
	body: string;
}

@Component({
	selector: 'login-modal',
	imports: [ModalComponent, TranslocoDirective, LoginFormComponent],
	styles: `
		/* The theme gives headings their own line-height: back to the font's. */
		h2 {
			width: fit-content;
			margin: 0 auto;
			padding: 2px 0 10px;
			font-size: var(--font-size-xl);
			font-weight: var(--font-weight-semibold);
			line-height: normal;
		}
		.login-prompt {
			max-width: 345px;
			margin: 0 auto 1.5rem;
			text-align: center;
			font-size: var(--font-size-normal);
			font-weight: var(--font-weight-medium);
			color: var(--modal-light-text-muted);
		}
		/* 345px of content in the design's 24px-padded modal. */
		.login-form {
			display: block;
			width: 345px;
			max-width: 100%;
		}
	`,
	changeDetection: ChangeDetectionStrategy.Eager,
	template: `
		<app-modal *transloco="let t" surface="light" (closed)="modalService.close('login')">
			<div modal-title>
				<h2>{{ t('message.info.logIn') }}</h2>
			</div>
			<div modal-body>
				<p class="login-prompt">{{ t('message.info.youMustBeLoggedInToUseThisFeature') }}</p>
				<login-form
					class="login-form"
					surface="light"
					[redirectOnSuccess]="false"
					(authenticated)="handleAuthentication($event)"
					(registering)="modalService.close('login', false)"
					/>
			</div>
		</app-modal>
	`
})
export class LoginModalComponent {
	constructor(
		public modalService: ModalService
	) {}

	public handleAuthentication(isAuthenticated: boolean): void {
		this.modalService.close('login', isAuthenticated)
	}
}
